import { render, staticRenderFns } from "./ReceiptIncomeReport.vue?vue&type=template&id=6f7b4780"
import script from "./ReceiptIncomeReport.vue?vue&type=script&lang=js"
export * from "./ReceiptIncomeReport.vue?vue&type=script&lang=js"
import style0 from "./ReceiptIncomeReport.vue?vue&type=style&index=0&id=6f7b4780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports